import Close16 from '@carbon/icons-react/es/close/16';
import React from 'react';
import styled from 'styled-components';
import { Drawer } from 'components/atoms/drawer';
import { DrawerContent } from 'components/organisms/task-pane/task-detail';

export const TimeOffDrawerStyled = styled(Drawer).attrs({
  placement: 'right',
  closeIcon: <Close16 />,
})`
  width: ${(props) => props.width || '360px'};
  .ant-drawer-body {
    padding: 0;
  }
`;

export const TimeOffDrawerContentStyled = styled(DrawerContent)`
  width: ${(props) => props.width || '360px'};

  .ant-table-thead {
    height: 2rem;
    position: sticky;
    top: 0;
    z-index: 1;
    .ant-table-cell {
      background-color: var(--coolest-gray-20);
    }
  }

  .ant-table-thead > tr > th {
    padding: 0.5rem;
    font-weight: var(--font-weight-bold);
  }

  ${DrawerContent.Content} {
    margin: var(--spacing-05);
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding-bottom: 63px;
    cursor: default;
  }

  ${DrawerContent.Footer} {
    position: absolute;
    background-color: var(--white-100);
    bottom: 0;
    width: 100%;
    height: 4rem;
  }

  .timeoff-header,
  .timeoff-history-header {
    display: flex;
    align-items: center;
    span:last-child {
      margin-left: 0.5rem;
    }
  }

  .timeoff-user-typeahead {
    min-height: 23rem;
  }

  .ant-form-item {
    padding-bottom: 0;
  }

  .timeoff-history-footer {
    display: flex;
    justify-content: flex-end;
  }

  .timeoff-date-picker-trigger {
    display: flex;
    width: 325px;
    align-items: center;
    justify-content: space-between;
    padding: var(--spacing-04) var(--spacing-05);
    background-color: var(--gray-10);
    resize: none;
    font-size: var(--font-size-base);
    line-height: var(--line-height-body-short-01);
    outline: 2px solid;
    outline-color: transparent;
    outline-offset: -2px;
    border: none;
    border-bottom: 1px solid var(--gray-50);
    border-radius: 0;

    span:last-child {
      color: var(--gray-100);
    }

    .calendar_date_text {
      span:last-child {
        color: var(--gray-50);
      }
    }

    svg {
      cursor: pointer;
    }
  }

  .timeoff-table-column-timeoff-date {
    display: flex;
    flex-direction: column;

    .timeoff-note {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: var(--gray-80);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 300px;
    }

    &.timeoff-deleted {
      color: var(--gray-50);
      .timeoff-history-datestring {
        text-decoration: line-through;
      }

      .timeoff-history-datediff {
        color: var(--gray-50);
      }

      .timeoff-note {
        color: var(--gray-80);
      }
    }
  }

  .ant-table-tbody > tr svg {
    visibility: hidden;
  }
  .ant-table-tbody > tr:hover svg {
    visibility: visible;
  }

  .timeoff-history-datediff {
    font-weight: 400;
    color: var(--gray-70);
    margin-left: 2px;
  }
`;
